module.exports = __webpack_public_path__ + "static/media/facial-capture-loading-base.93540ce8.svg";